/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import {
  AgencyDropdown,
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  BranchDropDown,
  Button,
  Col,
  FormInput,
  Icon,
  PreviewAltCard,
  PreviewCard,
  RotaStatusDropDown,
  Row,
  ShiftDropDown,
} from "../../../components/Component";
import RotaListing from "./RotaCalendar";
import { ButtonGroup } from "reactstrap";
import RotaList, { RotaType } from "./RotaList";
import {
  exportRotaAPI,
  showCarerListAPI,
  showClientListAPI,
  totalCarersEstimatehrsAPI,
  totalClientsEstimatehrsAPI,
} from "./RotaTableData";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { GradeTypeDropDownWithoutCarer } from "../../../components/dropdowns/GradeTypeDropDown";
import { ClientCarerBadge } from "../../../components/badge/GradeBadge";
import { PER_PAGE_ITEMS, RotaOptions, showErrorToast } from "../../../utils";
import { ImportExportButton } from "../../../components/button/ActionButton";
import DateRangePicker from "../../../components/input/date-time/DateRangePicker";
import {
  UserActionType,
  UserPermissionType,
  isAllowToAccess,
  isCheckToList,
} from "../../../services/permission/permission";
import { HourBadge } from "../../../components/badge/StatusBadge";

export const RotaCopyJob = {
  isRota: "ROTA",
  isCopy: "COPY",
  isJob: "JOB",
  isTraining: "TRAINING",
};

const Rotas = () => {
  const history = useHistory();
  const [status, setStatus] = useState({ id: 1, label: "Open", value: "OPEN" });
  const [grade, setGrade] = useState();
  const [branch, setBranch] = useState();
  const [shiftType, setShiftType] = useState();
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);
  const [showList, setShowList] = useState(false);
  const [showCarerList, setShowCarerList] = useState(false);
  const [carerClientList, setCarerClientList] = useState([]);
  const [selectedClientCarer, setSelectedClientCarer] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [matrixPageInfo, setMatrixPageInfo] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [sm, updateSm] = useState(false);
  const [isSwitchOn, setSwitchOn] = useState(false); // State for switch
  const [agency, setAgency] = useState({ id: 0, label: "All", value: "" });
  const [clientCarerHours, setClientCarerHours] = useState();
  const totalhours = clientCarerHours?.actualHours;

  useEffect(() => {
    if (showCarerList) {
      callCarerListApi();
    } else {
      callClientListApi();
    }
  }, [showCarerList, searchText, currentPage, branch]);

  useEffect(() => {
    if (!startDate || !endDate) return;
    if (showCarerList) {
      getTotalCarersHours();
    } else {
      getTotalClientsHours();
    }
  }, [showCarerList, searchText, branch, startDate, endDate]);

  useEffect(() => {
    if (!isSwitchOn && carerClientList.length > 0) {
      const initialItem = carerClientList.find((item) => item.id === selectedClientCarer?.id) || carerClientList[0];
      handleSelectCarer(initialItem);
    } else if (isSwitchOn) {
      handleSelectCarer(null);
    }
  }, [carerClientList, isSwitchOn]);

  useEffect(() => {
    const scrollableDiv = document.getElementById("scroll-matrix");
    scrollableDiv?.addEventListener("scroll", handleScroll, true);
    return () => {
      scrollableDiv?.removeEventListener("scroll", handleScroll, true);
    };
  }, [currentPage, isLoading]);

  const onExportClick = () => {
    if (!startDate && !endDate) return;
    setLoading(true);
    let params = {
      startDate: startDate,
      endDate: endDate,
      shiftType: shiftType?.value === "ANY" ? "" : shiftType?.value || null,
      status: status?.value === "OPEN" ? "ACTIVE" : status?.value,
      agencyId: agency?.id ?? null,
    };
    if (!showCarerList) {
      params.clientId = selectedClientCarer?.id;
    } else {
      params.carerId = selectedClientCarer?.id;
    }

    if (grade) {
      params.gradeId = grade.id;
    }

    if (branch) {
      params.branchId = branch?.id;
    }

    exportRotaAPI(params, (data, error) => {
      if (error === null) {
        window.open(data.fileUrl, "default");
      }
      setLoading(false);
    });
  };

  const toggleCalendar = () => {
    setShowCalendar(true);
    setShowList(false);
  };

  const toggleList = () => {
    setShowList(true);
    setShowCalendar(false);
  };

  const handleScroll = (e) => {
    const { scrollTop, clientHeight, scrollHeight } = e.target;

    if (scrollTop + clientHeight >= scrollHeight - 5 && !isLoading && currentPage !== matrixPageInfo?.totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const callCarerListApi = () => {
    setIsLoading(true);
    let params = {
      pageInfo: {
        pageIndex: currentPage,
        itemsPerPage: PER_PAGE_ITEMS,
      },
      status: ["ACTIVE", "ON_HOLD"],
      search: searchText || null,
      branchId: branch?.id ?? null,
    };

    showCarerListAPI(params, (data, error) => {
      if (error === null) {
        setMatrixPageInfo(data?.pageInfo);
        if (currentPage === 1) {
          setCarerClientList(data?.list);
        } else {
          setCarerClientList((prevList) => [...prevList, ...data?.list]);
        }
      } else {
        showErrorToast(error.message);
      }
      setIsLoading(false);
    });
  };

  const callClientListApi = () => {
    setIsLoading(true);
    let params = {
      pageInfo: {
        pageIndex: currentPage,
        itemsPerPage: PER_PAGE_ITEMS,
      },
      status: "ACTIVE",
      branchId: branch?.id ?? null,
      search: searchText || null,
    };

    showClientListAPI(params, (data, error) => {
      if (error === null) {
        setMatrixPageInfo(data?.pageInfo);
        if (currentPage === 1) {
          setCarerClientList(data?.list);
        } else {
          setCarerClientList((prevList) => [...prevList, ...data?.list]);
        }
      } else {
        showErrorToast(error.message);
      }
      setIsLoading(false);
    });
  };

  const getTotalClientsHours = () => {
    let params = {
      pageInfo: {
        pageIndex: currentPage,
        itemsPerPage: PER_PAGE_ITEMS,
      },
      branchId: branch?.id ?? null,
      search: searchText || null,
      startDate: startDate,
      endDate: endDate,
    };

    totalClientsEstimatehrsAPI(params, (data, error) => {
      if (error === null) {
        setClientCarerHours(data);
      }
    });
  };

  const getTotalCarersHours = () => {
    let params = {
      pageInfo: {
        pageIndex: currentPage,
        itemsPerPage: PER_PAGE_ITEMS,
      },
      branchId: branch?.id ?? null,
      search: searchText || null,
      startDate: startDate,
      endDate: endDate,
      status: ["ACTIVE", "ON_HOLD"],
    };

    totalCarersEstimatehrsAPI(params, (data, error) => {
      if (error === null) {
        setClientCarerHours(data);
      }
    });
  };

  const handleSelectCarer = (item) => {
    if (isSwitchOn && item) {
      setSwitchOn(false);
    }
    setSelectedClientCarer(item);
  };

  const handleSwitchToggle = () => {
    setSwitchOn(!isSwitchOn);
    setSearchText("");
  };

  const handleDatePickerChange = (startDate, endDate) => {
    setStartDate(startDate);
    setEndDate(endDate);
  };

  const onAddClick = () => {
    history.push(`${process.env.PUBLIC_URL}/add-job`, {
      type: RotaCopyJob.isRota,
      selectedClientCarer: selectedClientCarer,
    });
  };

  const toggleClientList = () => {
    setShowCarerList(false);
    setCurrentPage(1);

    // Restore the scroll position for Client list
    setTimeout(() => {
      const scrollableDiv = document.getElementById("scroll-matrix");
      // scrollableDiv.scrollTop = clientScrollPosition;
      scrollableDiv.scrollTop = 0;
    });
  };

  const toggleCarerList = () => {
    setShowCarerList(true);
    setCurrentPage(1);

    // Restore the scroll position for Carer list
    setTimeout(() => {
      const scrollableDiv = document.getElementById("scroll-matrix");
      // scrollableDiv.scrollTop = carerScrollPosition;
      scrollableDiv.scrollTop = 0;
    });
  };

  return (
    <React.Fragment>
      <Head title="Rota" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween className="align-items-start">
            <BlockHeadContent className="w-320px">
              <ul className="d-flex justify-content-between">
                <li>
                  <BlockTitle page className="">
                    Rota
                  </BlockTitle>
                </li>
                <li>
                  <ButtonGroup className="">
                    <Button
                      className={`btn-dim btn-white ${!showList ? "bg-purple btn-lighter" : ""}`}
                      onClick={toggleCalendar}
                    >
                      <Icon name="calendar-alt" />
                    </Button>
                    <Button
                      className={`btn-dim btn-white ${showList ? "bg-purple btn-lighter" : ""}`}
                      onClick={toggleList}
                    >
                      <Icon name="view-list-fill" />
                    </Button>
                  </ButtonGroup>
                </li>
              </ul>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <Button
                  className={`btn-icon btn-trigger toggle-expand me-n1 ${sm ? "active" : ""}`}
                  onClick={() => updateSm(!sm)}
                >
                  <Icon name="more-v" />
                </Button>
                <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                  <ul className="nk-block-tools g-2 d-flex flex-wrap justify-content-end">
                    <li>
                      <BranchDropDown
                        value={branch}
                        isClearable
                        isShowAll
                        className="w-225px"
                        placeholder="Branch"
                        onSelect={(selectedBranch) => setBranch(selectedBranch)}
                      />
                    </li>
                    <li>
                      <GradeTypeDropDownWithoutCarer
                        value={grade}
                        isClearable
                        isShowAll
                        className="w-225px"
                        placeholder="Grade Type"
                        onSelect={(selectedGrade) => setGrade(selectedGrade)}
                      />
                    </li>
                    <li>
                      <RotaStatusDropDown value={status} className="w-125px" onSelect={(e) => setStatus(e)} />
                    </li>
                    <li className="">
                      <AgencyDropdown
                        isShowAll={true}
                        className="w-150px"
                        value={agency}
                        onSelect={(e) => {
                          setAgency(e);
                        }}
                      />
                    </li>
                    <li>
                      <ShiftDropDown
                        className="w-120px"
                        isAny={true}
                        value={shiftType}
                        onSelect={(selectedShift) => setShiftType(selectedShift)}
                      />
                    </li>
                    <li>
                      <DateRangePicker onDateChange={handleDatePickerChange} />
                    </li>
                    {isAllowToAccess(UserPermissionType.rota, UserActionType.export) && (
                      <li>
                        <ImportExportButton
                          title="Export"
                          onClick={onExportClick}
                          iconName="arrow-up"
                          loading={loading}
                        />
                      </li>
                    )}
                    {isAllowToAccess(UserPermissionType.rota, UserActionType.add) && (
                      <li>
                        <ImportExportButton addButton title="Add" onClick={onAddClick} iconName="plus" />
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        {showCarerList &&
          (() => {
            const { capHours, holdFromDate, restrictions } = selectedClientCarer || {};

            return (
              <div className="hour-cap-container">
                <div className="d-flex flex-wrap align-items-center justify-content-center" style={{ gap: "10px" }}>
                  {capHours > 0 && (
                    <div className="hour-cap-badge w-auto">
                      <span className="text-white fw-bold">{`Hour Cap: ${capHours} hours`}</span>
                    </div>
                  )}
                  {holdFromDate && (
                    <div className="hour-cap-badge w-auto">
                      <span className="text-white fw-bold">{`Hold From: ${holdFromDate}`}</span>
                    </div>
                  )}
                </div>

                {restrictions && (
                  <div className="hour-cap-note">
                    <span className="text-white fw-bolder">{`Restrictions: ${restrictions}`}</span>
                  </div>
                )}
              </div>
            );
          })()}

        <Block>
          {isCheckToList(UserPermissionType.rota) ? (
            <PreviewCard className="height-matrix-card rota-inner-card">
              <div className="d-flex h-100">
                <div className="filter-div">
                  <Row className="row-carer-filter">
                    <Col size="12" className="carer-filter-height">
                      <div className="d-flex justify-content-between align-items-center pe-3 mb-2">
                        <div className="align-center">
                          Filter
                          <label className="switch ms-2 me-2">
                            <input type="checkbox" checked={isSwitchOn} onChange={handleSwitchToggle} />
                            <span className="slider-rotas round"></span>
                          </label>
                          ALL
                        </div>
                        {carerClientList.length > 0 && totalhours > 0 && (
                          <HourBadge color="primary" text={`Total hours: ${totalhours?.toFixed(2)}`}/>
                        )}
                      </div>
                      <FormInput
                        baseClass="pe-3"
                        labelGroupClass="m-0"
                        disabled={isSwitchOn}
                        value={searchText || ""}
                        placeholder={!showCarerList ? "Search Client" : "Search Carer"}
                        onTextChange={(text) => setSearchText(text)}
                      />

                      <ButtonGroup className="buttongrp-carer pe-3">
                        <Button
                          className={`btn-dim bg-light text-center d-flex justify-content-center ${
                            !showCarerList ? "bg-purple text-white btn-lighter" : ""
                          }`}
                          onClick={toggleClientList}
                        >
                          Client
                        </Button>
                        <Button
                          className={`btn-dim bg-light text-center d-flex justify-content-center ${
                            showCarerList ? "bg-purple text-white btn-lighter" : ""
                          }`}
                          onClick={toggleCarerList}
                        >
                          Carer
                        </Button>
                      </ButtonGroup>
                      <div className="carer_client_filter" id="scroll-matrix">
                        {carerClientList?.map((item, id) => (
                          <Col size="12" key={id}>
                            <ClientCarerBadge
                              carerImage={item.carerImage?.imageUrl}
                              isCarer={showCarerList}
                              // className="mt-2"
                              className={id === carerClientList.length - 1 ? "mt-2 mb-2" : "mt-2"}
                              label={item.name}
                              phoneNumber={`+${item.phoneNumber}`}
                              color={selectedClientCarer && selectedClientCarer.id === item.id ? "success" : "light"}
                              selected={selectedClientCarer && selectedClientCarer.id === item.id}
                              onClick={() => handleSelectCarer(item)}
                            />
                          </Col>
                        ))}
                      </div>
                    </Col>
                  </Row>
                </div>
                {isSwitchOn || (!isSwitchOn && selectedClientCarer?.id) ? (
                  <>
                    {showList ? (
                      <>
                        {isSwitchOn || (!isSwitchOn && selectedClientCarer?.id) ? (
                          <RotaListing
                            startDate={startDate}
                            endDate={endDate}
                            branchId={branch?.id}
                            gradeId={grade?.id}
                            agencyId={agency?.id}
                            shiftType={shiftType}
                            type={showCarerList ? RotaType.carer : RotaType.hospital}
                            carerId={showCarerList ? selectedClientCarer?.id : 0}
                            clientId={!showCarerList ? selectedClientCarer?.id : 0}
                            status={status?.value || RotaOptions.open}
                            selectableRows={true}
                            onRowSelectionChange={(rows) => setSelectedRows(rows)}
                            isSwitchOn={isSwitchOn}
                          />
                        ) : (
                          <></>
                        )}
                      </>
                    ) : (
                      <>
                        <RotaList
                          startDate={startDate}
                          isSwitchOn={isSwitchOn}
                          branchId={branch?.id}
                          gradeId={grade?.id}
                          agencyId={agency?.id}
                          shiftType={shiftType}
                          endDate={endDate}
                          type={showCarerList ? RotaType.carer : RotaType.hospital}
                          carerId={showCarerList ? selectedClientCarer?.id : 0}
                          clientId={!showCarerList ? selectedClientCarer?.id : 0}
                          status={status?.value || RotaOptions.open}
                          selectableRows={true}
                          onRowSelectionChange={(rows) => setSelectedRows(rows)}
                        />
                      </>
                    )}
                  </>
                ) : (
                  <></>
                )}
              </div>
            </PreviewCard>
          ) : (
            <PreviewAltCard>
              <span className="d-flex justify-content-center">You do not have permission</span>
            </PreviewAltCard>
          )}
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default Rotas;
